<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />
    <Breadcrumb :links="breadCrumbData" />
    <Carrusel />

    <div v-if="permiso">
      <Main
        :userPermissions="userPermissions"
        :userPermission="userPermission"
      />
    </div>

    <div v-else>
      <NotPermission :contenido="contenidoLock" />
    </div>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import Carrusel from "../../../components/private/Carrusel.vue";
import Main from "./permission/Main.vue";
import NotPermission from "@/components/private/TextNotPermisionPrueba.vue";
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    Main,
    NotPermission,
  },
  data() {
    return {
      permiso: false,
      breadCrumbData: null,
      contenidoLock: null,
      userPermissions: true,
      userPermission: true,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Desafíos",
          routeName: "desafio",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      console.log(relacionUs);
      if (
        relacionUs.permisos.find((p) => p.permisoId === 4) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 5 ||
        relacionUs.rolId === 4
      ) {
        this.permiso = true;
      }
    },
    obtenerContenido: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "desafios",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        if (res.data) {
          this.contenidoLock = res.data.info.content;
        }
        console.log("Datos",res.data)
      } catch (error) {
        console.log(error);
      }
    },

    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const data = JSON.parse(localStorage.getItem("user"));
        const relacionUs = data.servicios.find(
          (s) => s.id === parseInt(this.$route.params.idServicio)
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);

        //funcionario Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Jefe de Servicio BGI Borrador
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        }

        //Jefe de Servicio BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        }

        //Funcionario
        if (relacionUs.rolId === 5) {
          this.userPermission = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerContenido();
    this.obtenerRevision();
  },
};
</script>
